import axios from "@/helper/axios";
const state = {
  vendor_details : false,
  public_messages : {}
}
const actions = {
  fetchVendor({commit},vendorId){
    axios.get("/vendor/details?vendor_id=" + vendorId)
    .then(function (response) {
      commit('setVednor',response.data.data)
    })
    .catch(function (e) {
      console.log(e);
    });
  },
}
const getters = {}
const mutations = {
  setVednor(state,data){
    state.vendor_details = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}